export default __webpack_public_path__ + "static/media/Graphics_grandmother-without-dieline-scaled-min.ee908b75.jpg";